import React from 'react'
import {styled} from '@material-ui/core/styles'
import {useAudienceTypesState} from 'lms/hooks'
import SectionTitle from 'lms/components/Detail/SectionTitle'

const List = styled('ul')({})

const Value = styled('li')({})

const nameSorter = (a, b) => a.localeCompare(b)

const AudienceTypes = ({audienceTypes}) => {
  const {status, data} = useAudienceTypesState()

  if (status !== 'succeeded' || audienceTypes.length === 0) return null

  const names = audienceTypes.map(id => data.byId[id] && data.byId[id].name).sort(nameSorter)

  const namesFiltered = names.filter(element =>
    element !== undefined && element !== 'B2B' && element !== 'B2C' && element !== 'Customers' && element !== 'Other'
  )

  if (namesFiltered.length === 0) return null

  return (
    <>
      <SectionTitle>Learner(s) Groups</SectionTitle>
      <List>
        {namesFiltered.map(name => (
          <Value key={name}>{name}</Value>
        ))}
      </List>
    </>
  )
}

export default AudienceTypes
